<script lang="ts">
import { AccountStatus } from '@smartsupp/websocket-client-visitor'

import { testIds } from '@/constants'
import { groupedAgents } from '@/modules/agents/groupedAgents'
import { messageWithBotIdentity } from '@/modules/botIdentities'
import { accountStatus, isChatAssigned } from '@/modules/chat'
import { isFullScreenEnabled } from '@/modules/device'
import { t } from '@/modules/translations'

import Fade from './WidgetHeaderFade.svelte'
</script>

<div
	class={['font-medium truncate leading-6', $isFullScreenEnabled ? 'text-base' : 'text-lg']}
	data-testid={testIds.headerTitle}
>
	{#if $isChatAssigned}
		<Fade>{$groupedAgents.map((a) => a.fullname).join(', ')}</Fade>
	{:else if $messageWithBotIdentity}
		<Fade>{$messageWithBotIdentity.name}</Fade>
	{:else if $accountStatus === AccountStatus.Online}
		<Fade>{$t('topBar.online.hello')}</Fade>
	{:else if $accountStatus === AccountStatus.Offline}
		<Fade>{$t('topBar.offline.hello')}</Fade>
	{/if}
</div>
